import { Classroom } from '@/api/classroom'
import moment from 'moment'

const state = () => ({
    webinars: [],
    webinar: null,
    LoadingWebinar: false,
    isSuccessWebinar: true,
    messageWebinar: '',
    savedIdClassroomWebinar: 0,
    savedIdWebinar: 0,
    createdWebinar: {},
})

const getters = {
    webinarList: state => state.webinars,
    webinar: state => state.webinar,
    isLoadingWebinar: state => state.isLoadingWebinar,
    isSuccessWebinar: state => state.isSuccessWebinar,
    messageWebinar: state => state.messageWebinar,
    savedIdClassroomWebinar: state => state.savedIdClassroomWebinar,
    savedIdWebinar: state => state.savedIdWebinar,
    createdWebinar: state => state.createdWebinar,
}

const actions = {
    async fetchAllWebinars({ commit }, query) {
        commit('setWebinarIsLoading', true)
        commit('setSavedIdClassroomWebinar', query.classroomId)
        await Classroom.webinarList(query.classroomId, query.isExpired)
            .then(response => {
                commit('setWebinars', response.data.data)
                commit('setWebinarIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setWebinarIsLoading', false)
            })
    },
    async fetchDetailWebinar({ commit }, id) {
        commit('setWebinarIsLoading', true)
        await Classroom.webinarDetail(id)
            .then(response => {
                commit('setWebinarDetail', response.data.data)
                commit('setWebinarIsLoading', false)
                commit('setSavedIdWebinar', response.data.data.id)
            })
            .catch(error => {
                console.log(error)
                commit('setWebinarIsLoading', false)
            })
    },
    async updateWebinar({ commit }, webinar) {
        const id = webinar.id
        const payload = webinar.payload

        await Classroom.webinarUpdate(id, payload)
            .then(response => {
                if (response.data.success) {
                    commit('setCreatedWebinar', response.data.data)
                    commit('setSuccessWebinar', true)
                    commit('setMessageWebinar', 'Berhasil Mengubah Webinar')
                } else {
                    commit('setSuccessWebinar', false)
                    commit('setMessageWebinar', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessWebinar', false)
                commit('setMessageWebinar', error.errors[0].message)
            })
    },
    async updateWebinarThumbnail({ commit }, webinar) {
        const id = webinar.id
        const payload = webinar.payload

        await Classroom.webinarUpdateWithThumbnail(id, payload)
            .then(response => {
                if (response.data.success) {
                    commit('setCreatedWebinar', response.data.data)
                    commit('setSuccessWebinar', true)
                    commit('setMessageWebinar', 'Berhasil Mengubah Webinar')
                } else {
                    commit('setSuccessWebinar', false)
                    commit('setMessageWebinar', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessWebinar', false)
                commit('setMessageWebinar', error.errors[0].message)
            })
    },
    async addWebinar({ commit }, payload) {
        await Classroom.webinarAddWithThumbnail(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setCreatedWebinar', res.data.data)
                    commit('setSuccessWebinar', true)
                    commit('setMessageWebinar', 'Berhasil Menambahkan Webinar')
                } else {
                    commit('setSuccessWebinar', false)
                    commit('setMessageWebinar', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessWebinar', false)
                commit('setMessageWebinar', error.errors[0].message)
            })
    },
    async deleteWebinar({ commit }, id) {
        await Classroom.webinarDelete(id)
            .then(res => {

                if (res.data.success) {
                    commit('setSuccessWebinar', true)
                    commit('setMessageWebinar', 'Berhasil Menghapus Webinar')
                } else {
                    commit('setSuccessWebinar', false)
                    commit('setMessageWebinar', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessWebinar', true)
                commit('setMessageWebinar', error.errors[0].message)
            })
    }
}

const mutations = {
    setWebinars: (state, webinars) => {
        state.webinars = webinars.map((item) => ({
          ...item,
          status: moment(item.expired_at).isBefore() ? "expired" : "active",
        }));
    },

    setWebinarDetail: (state, webinar) => {
        state.webinar = webinar
    },

    setWebinarIsLoading: (state, isLoadingWebinar) => {
        state.isLoadingWebinar = isLoadingWebinar
    },

    setSuccessWebinar: (state, isSuccessWebinar) => {
        state.isSuccessWebinar = isSuccessWebinar
    },

    setMessageWebinar: (state, messageWebinar) => {
        state.messageWebinar = messageWebinar
    },
    setSavedIdClassroomWebinar: (state, savedIdClassroomWebinar) => {
        state.savedIdClassroomWebinar = savedIdClassroomWebinar
    },
    setSavedIdWebinar: (state, id) => {
        state.savedIdWebinar = id
    },
    setCreatedWebinar: (state, webinar) => {
        state.createdWebinar = webinar
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}